export const getContrast = (hexcolor) => {
	if (!hexcolor) {
		return '#000';
	}

	let hex = hexcolor;

	if (!/^#[0-9A-F]{6}$/i.test(hex)) return '#000';

	// If a leading # is provided, remove it
	if (hex.slice(0, 1) === '#') {
		hex = hexcolor.slice(1);
	}

	// If a three-character hexcode, make six-character
	if (hex.length === 3) {
		hex = hexcolor.split('').map((hex) => hex + hex).join('');
	}

	// Convert to RGB value
	const r = parseInt(hex.slice(0, 2), 16);
	const g = parseInt(hex.slice(2, 4), 16);
	const b = parseInt(hex.slice(4, 6), 16);

	// Get YIQ ratio
	const yiq = ((r * 299) + (g * 587) + (b * 114)) / 1000;

	// Check contrast
	return (yiq >= 128) ? '#000' : '#fff';
};
